"use strict";

import { commonConstants } from "../../_redux/_constants";

export function ajaxError(error) {
  return {
    type: commonConstants.AJAX_ERROR,
    payload: error,
  };
}

export function ajaxSuccess(message) {
  return {
    type: commonConstants.AJAX_SUCCESS,
    payload: message,
  };
}

export function hideSuccessMessage() {
  return {
    type: commonConstants.HIDE_SUCCESS_SERVER_MESSAGE,
  };
}

export function hideCustomeError(code) {
  return {
    type: commonConstants.HIDE_ERROR_CUSTOM_SERVER_MESSAGE,
    payload: code,
  };
}

export function hideConfirmServerError() {
  return {
    type: commonConstants.HIDE_ERROR_CONFIRM_SERVER_MESSAGE,
  };
}

export function hideError(code) {
  return {
    type: commonConstants.HIDE_ERROR_SERVER_MESSAGE,
  };
}

export function frontEndMessage(error) {
  return {
    type: commonConstants.FRONTEND_MESSAGE,
    payload: error,
  };
}

export function hideFrontEndMessage() {
  return {
    type: commonConstants.HIDE_FRONTEND_MESSAGE,
  };
}
